"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
  mutation changePassword($currentPassword: String!, $newPasswordRepeated: String!, $newPassword: String!) { 
    changePassword(currentPassword: $currentPassword, newPasswordRepeated: $newPasswordRepeated, newPassword: $newPassword) {
      success 
      messages
    } 
  }
`;
//# sourceMappingURL=changePasswordQuery.js.map